import { Component, OnInit, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { NgForm, FormBuilder, FormControl, FormsModule, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

// Services
import { HazardServices } from '../../Services/HazardServices';
import { InductryMasterServices } from '../../Services/InductryMaster';
import { UserHazardService } from '../../Services/UserHazardService';
import { CheckAuth } from '../../Services/UtilityService';
import { CompanyServices } from '../../Services/CompanyServices';
import { UserLocationServices } from '../../Services/UserLocationServices';
import { UserPlanFormatingService } from '../../Services/UserPlanFormatingService';

// Models
import { hazardMaster } from '../../Models/HazardMasterModel';
import { CompanyModel } from '../../Models/CompanyModel';
import { CommentStmt, ParseError } from '@angular/compiler';
import { inductryMaster } from '../../Models/InductryMasterModel';
import { UserHazardModel } from '../../Models/UserHazardModel';
import { tokenDetail } from '../../Models/tokenDetail';
import { AppComponent } from '../app.component';
import { UserLocationModel } from '../../Models/UserLocationModel';
import { UserPlanFormatingModel } from '../../Models/UserPlanFormatingModel';
//import { debounce } from 'rxjs/operator/debounce';
import { Message } from 'primeng/api';
import { LoginComponent } from '../login/login.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from 'read-appsettings-json';

@Component({
  templateUrl: './Preferences.component.html'
})

export class Preferences implements OnInit {
  tokenKey: string = '';
  appModel: any;
  duplicateerror: boolean;
  userID: number;
  hMaster: hazardMaster[];
  filterhMaster: hazardMaster[];
  finalhMaster: number[] = [];
  uHazardModel = new UserHazardModel();
  uHazard: UserHazardModel[] = [];
  inductryMaster: inductryMaster[];
  selectedAll: any;
  uPrefInfoId: number;
  //companyObject: CompanyModel = {};
  companyModel: CompanyModel = {
    userPreferenceBasicInfoId: null,
    companyName: null,
    companyAddress: null,
    city: null,
    state: null,
    phone: null,
    userId: null,
    createdBy: null,
    modifiedBy: null,
  };
  statusCode: number;
  isCheckDuplicateInductryinArray: boolean = false;
  currentIndex: number = 0;
  locationlist: UserLocationModel[];
  public questionList: UserPlanFormatingModel | undefined;
  @ViewChildren('myInput') mc;
  @ViewChildren('myhdnInput') mhc;
  public anslist = [];
  logofile: any;
  PreferencesForm: FormGroup;
  successMessage: any;
  isshowsuccess: boolean;
  errorMessage: any;
  isshowerror: boolean;
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showerror(msg) {
    this.errorMessage = msg;
    this.isshowerror = true;
    this.isshowsuccess = false;
    window.scrollTo(0, 0);
  }
  hideerror() {
    this.errorMessage = "";
    this.isshowerror = false;
  }
  showsuccess(msg) {
    this.successMessage = msg;
    this.isshowsuccess = true;
    this.isshowerror = false;
    window.scrollTo(0, 0);
  }
  value: number = 0;
  msgs: Message[] = [];

  //Preferences = new FormGroup({
  //    userPreferenceBasicInfoId: new FormControl(),
  //    companyName: new FormControl(),
  //    companyAddress: new FormControl(),
  //    city: new FormControl(),
  //    phone: new FormControl(),
  //    state: new FormControl(),
  //    userId: new FormControl(),
  //    inductryList: new FormControl(),
  //});

  constructor(private _fb: FormBuilder, private http: HttpClient, private router: Router, private elRef: ElementRef, private hazardServices: HazardServices, private inductryServices: InductryMasterServices, private userHazardService: UserHazardService, private checkAuth: CheckAuth, private companyServices: CompanyServices, private uLocaionServices: UserLocationServices, private uPlanformatServices: UserPlanFormatingService, private logincomp: LoginComponent) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('UserId'));

    this.PreferencesForm = this._fb.group({
      userPreferenceBasicInfoId: 0,
      companyName: [''],
      companyAddress: [''],
      city: [''],
      state: [''],
      phone: [''],
      userId: this.userID,
      createdBy: this.userID,
      createdDate: Date,
      modifiedBy: this.userID,
      modifiedDate: Date
    })
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.appModel = AppSettings.Current().ConnectionStrings;
    window.scrollTo(0, 0);
    this.duplicateerror = false;
    this.GetCompany();
  }

  GetCompany(): void {
    this.companyServices.GetCompanyFindByUserID(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["companyDetails"] != null) {
          this.PreferencesForm.setValue(data["companyDetails"][0]);
          this.uPrefInfoId = parseInt(data["companyDetails"][0].userPreferenceBasicInfoId);
          this.GetUserLocation();
        }
        else {
          this.uPrefInfoId = 0;
        }
      },
      error => this.statusCode = error,
    );
  }

  pushUserHazardinArray(obj: hazardMaster[]) {
    this.finalhMaster = [];
    for (let iCounter = 0; iCounter < obj.length; iCounter++) {
      this.finalhMaster.push(parseInt(obj[iCounter].hazardMasterId));
    }

    //let obj = this.hMaster.filter((item) => item.isSelected == true);
  }

  GetHazardMaster(industryId: number): void {
    this.hazardServices.GetHazardMasterFindByUserID(this.tokenKey, this.userID, industryId).subscribe(
      data => {
        this.hMaster = data["hazardMaster"];
        this.filterhMaster = this.hMaster;
        let obj = this.hMaster.filter((item) => item.isSelected == true);
        this.pushUserHazardinArray(obj);
        this.unblockDocument();
      },
      error => this.statusCode = error,
    );
  }

  GetInductryMaster(): void {
    this.inductryServices.GetInductryMaster(this.tokenKey).subscribe(
      data => {
        this.inductryMaster = data["inductryMaster"];
        this.GetHazardMaster(0);
      },
      error => this.statusCode = error,
    );
  }

  filterForeInductry(filterVal: any) {
    //if (filterVal == "-1") {
    //  this.hMaster = this.filterhMaster;
    //}
    //else {
      //this.hMaster = this.filterhMaster.filter((item) => item.industryId == filterVal);
      this.GetHazardMaster(filterVal);
    //}
  }

  selectAllInductry(event: any) {
    for (var i = 0; i < this.hMaster.length; i++) {
      this.hMaster[i].isSelected = event.currentTarget.checked;
      if (event.currentTarget.checked) {
        this.finalhMaster.push(parseInt(this.hMaster[i].hazardMasterId));
      }
      else {
        this.finalhMaster = [];
      }
    }
  }

  pushInductryInArray(id: any, event: any) {
    if (this.finalhMaster != undefined) {
      if (this.finalhMaster.length > 0) {
        //for (let iCounter = 0; iCounter < this.finalhMaster.length; iCounter++) {
        //    if (this.finalhMaster[iCounter] === id) {
        //        //this.currentIndex = iCounter;
        //        //this.isCheckDuplicateInductryinArray = true;
        //        //this.finalhMaster.splice(this.currentIndex, 1);

        //    }
        //}
        this.finalhMaster = this.removeElemetninArray(this.finalhMaster, id);
      }
      else
        this.isCheckDuplicateInductryinArray = false;
    }

    if (this.isCheckDuplicateInductryinArray == false && event.currentTarget.checked) {
      this.finalhMaster.push(id);
    }
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  //locationlist = [{ locationId: 0, location: '', displayOrder: 1, userId: this.userID, createdBy: this.userID }];
  addlocation() {
    let displayorder = this.locationlist.length + 1;
    this.locationlist.push({ locationId: 0, location: '', displayOrder: displayorder, userId: this.userID, createdBy: this.userID, modifiedBy: this.userID, isDeleted: false });
  }
  templist = [];
  removelocation(ind) {
    debugger;
    let data = this.locationlist.find((thing, index, self) => index === ind)
    if (data.locationId > 1) {
      data.isDeleted = true;
    }
    else {
      this.locationlist.splice(ind, 1);
    }
  }

  GetUserLocation(): void {
    this.uLocaionServices.GetUserLocation(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["userLocation"].length > 0 && data["userLocation"] != undefined) {
          this.locationlist = data["userLocation"];
        }
        else {
          this.locationlist = [{ locationId: 0, location: '', displayOrder: 0, userId: this.userID, createdBy: this.userID, modifiedBy: this.userID, isDeleted: false }];
        }
        this.getQuestionsans();
      },
      error => this.statusCode = error,
    );
  }

  getQuestionsans() {
    this.uPlanformatServices.getQuestions(1, this.tokenKey, this.userID).subscribe(
      //data => this.questionList = data.questionMaster
      data => {
        if (data.questionMaster != null) {
          this.questionList = data.questionMaster;
        }
        else {
          this.showerror(data["status"]);
          this.unblockDocument();
        }
        this.GetInductryMaster();
      },
      error => {
        console.log(JSON.stringify(error.json()));
      }
    )
  }

  logoradioChange(event) {
    let toArray = event.target.name.split("_");
    let conditionalid = 0;
    if (toArray.length > 1) {
      conditionalid = toArray[1];
      if (conditionalid > 0) {
        let ele = this.elRef.nativeElement.querySelector('.conditional_' + conditionalid);
        if (ele != null) {
          if (event.target.value.toLowerCase() == "yes") {
            this.elRef.nativeElement.querySelector('.conditional_' + conditionalid).hidden = false;
          }
          else {
            this.elRef.nativeElement.querySelector('.conditional_' + conditionalid).hidden = true;
          }
        }
      }
    }
  }

  downloadFile(filename) {
    this.uPlanformatServices.downloadFile(filename, this.userID)
      .subscribe()
  }

  fileExtension: any;
  fileEvent(event): any {
    debugger;
    //*-- this function gets content of uploaded file and validation -- * /
    var file = event.target.files[0];
    this.logofile = file.name;    
    let size = Math.round(file.size / 1024);
    if (size <= 4000) {
      var allowedExtensions =
        ["gif", "jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "GIF"];
      this.fileExtension = this.logofile.split('.').pop();

      if (!this.isInArray(allowedExtensions, this.fileExtension)) {
        this.showerror("You have selected an invalid image file type. EHS Plan Builder supports four image formats: GIF, PNG, JPEG, JPG.");
        this.unblockDocument();
      }
      else {
        this.hideerror();
      }
    }
    else {
      this.showerror("You have selected an larger image file. EHS Plan Builder supports file upto 4MB.");
      this.unblockDocument();
    }
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  showSuccess(message) {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: message });
  }

  showInfo(message) {
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Info Message', detail: message });
  }

  showWarn(message) {
    this.msgs = [];
    this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: message });
  }

  showError(message) {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: 'Error Message', detail: message });
  }


  savePreferences(Preferences: NgForm) {
    debugger;
    this.blockDocument();
    if (Preferences.valid) {
      if (this.uPrefInfoId > 0) {
        this.companyModel = Preferences.value;
        this.companyModel.userId = this.userID.toString();
        this.companyModel.userPreferenceBasicInfoId = this.uPrefInfoId.toString();
        this.companyModel.modifiedBy = this.userID.toString();
        this.companyServices.UpdateCompany(this.tokenKey, this.companyModel).subscribe(
          successCode => {
            this.statusCode = successCode;
            if (this.statusCode !== undefined) {
              this.savelocation()
            }
          }, errorCode => this.statusCode = errorCode
        );
      }
    }
  }

  savehazard() {
    if (this.finalhMaster.length > 0) {
      for (let iCouter = 0; iCouter < this.finalhMaster.length; iCouter++) {
        this.uHazardModel = new UserHazardModel();
        this.uHazardModel.Userid = this.userID;
        this.uHazardModel.HazardMasterId = parseInt(this.finalhMaster[iCouter].toString());
        this.uHazardModel.CreatedBy = this.userID;
        this.uHazard.push(this.uHazardModel);
      }
      this.userHazardService.SaveHazardMaster(this.tokenKey, this.uHazard)
        .subscribe(successCode => {
          this.statusCode = successCode;
          this.finalhMaster = [];
          this.uHazard = [];
          //this.GetHazardMaster();
          this.GetCompany();
          this.showsuccess("Preferences Updated Successfully");
        }, errorCode => this.statusCode = errorCode);
    }
    else {
      this.finalhMaster = [];
      this.uHazard = [];
      this.GetCompany();
      this.showsuccess("Preferences Updated Successfully");
    }
  }

  savelocation() {
    // Remove duplicate location and blank data.       
    this.locationlist = this.locationlist.filter((thing, index, self) =>
      index === self.findIndex((t) => (
        t.location === thing.location && t.location !== ""
      ))
    )

    // Save Location
    this.uLocaionServices.SaveLocationdMaster(this.tokenKey, this.locationlist)
      .subscribe(successCode => {
        this.statusCode = successCode;
        if (this.statusCode !== undefined) {
          this.locationlist = [];
          //this.GetUserLocation();
          this.saveformating();
        }
        else {
          this.showerror(this.statusCode["status"]);
          this.unblockDocument();
        }
      }, errorCode => {
        this.statusCode = errorCode;
        this.showerror(this.statusCode["status"]);
        this.unblockDocument();
      });
  }

  saveformating() {
    //console.log(this.vc.first.nativeElement);
    var controllist = document.getElementsByClassName("ehs_textrow");
    this.anslist = [];
    for (let i = 0; i < this.mc._results.length; i++) {
      let questionid = 0;
      let Ans;
      let LogoFile;
      if (this.mc._results[i].nativeElement.type == 'select-one') {
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        Ans = this.mc._results[i].nativeElement.value;
      }
      else if (this.mc._results[i].nativeElement.type == 'radio') {
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        Ans = "";
        if (this.mc._results[i].nativeElement.checked) {
          Ans = this.mc._results[i].nativeElement.value;
        }
        i++;
        if (this.mc._results[i].nativeElement.checked) {
          Ans = this.mc._results[i].nativeElement.value;
        }
      }
      else if (this.mc._results[i].nativeElement.type == 'file') {
        Ans = "";
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        if (!this.mc._results[i].nativeElement.parentElement.parentElement.hidden) {
          if (this.mc._results[i].nativeElement.files[0] != undefined) {
            Ans = this.mc._results[i].nativeElement.files[0].name;
            this.logofile = this.mc._results[i].nativeElement.files[0];
            LogoFile = this.logofile;
          }
          i++;
          if (this.mc._results[i].nativeElement.tagName == 'A') {
            if (this.mc._results[i].nativeElement.id.split('_').length > 1 && LogoFile == undefined) {
              Ans = this.mc._results[i].nativeElement.id.replace("filename_", "");
            }
          }
          else {
            i--;
          }
        }
        else {
          Ans = "";
          this.logofile = undefined;
          if (this.mc._results[i].nativeElement.tagName == 'A') {
            i++;
          }
        }
      }
      if (questionid > 0) {
        this.anslist.push({ QuestionId: questionid, AnswerText: Ans, UserId: this.userID, CreatedBy: this.userID });
      }
    }
    // Save Formating 
    this.uPlanformatServices.saveans(this.anslist, this.logofile, this.tokenKey).subscribe(
      data => {
        debugger
        if (data.status == 'Success') {
          if (this.logofile !== undefined) {
            //this.uploadFile(this.logofile, this.userID, res.logoFileName).subscribe();
            this.uPlanformatServices.uploadFile(this.logofile, this.userID, data.logoFileName, this.tokenKey)
              .subscribe(data => {
                //this.getQuestionsans();
              })
          }
          else {
            //this.getQuestionsans();
          }
          this.savehazard();
        }
        else {
          this.showerror(data["status"]);
          this.unblockDocument();
        }
      }, error => {
        this.showerror(error);
        this.unblockDocument();
      })
  }
}
